module.exports = __webpack_public_path__ + "media/img/frontend_application/myfavourite-blank-771beaa5ca4145aa000719fb353f52db.png";